import { getOptions } from '@/utils'

const getters = {
  uid: (state) => state.user.uid,
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
  signInfo: (state) => state.user.signInfo,
  openid: (state) => state.user.signInfo.openid,
  goodsList: (state) => state.goods.goodsList,
  signList: (state) => state.goods.signList,
  selectIds: (state) => state.student.selectArray,
  selectNum: (state) => state.student.selectArrayIds.length,
  studentList: (state, getters) => state.student.studentList,
  selectArrayIds: (state, getters) => state.student.selectArrayIds,
  selectArray: (state, getters) => state.student.selectArray, // 选中人
  activeAll: (state, getters) => state.student.studentList.every((val) => getters.selectArrayIds.includes(val.userId)), // 是否全部勾选
  beGoSms: (state, getters) => state.student.beGoSms, // 预备发短信的选中人
  courseTreeList: (state) => state.student.courseTreeList,
  dictMap: (state) => state.student.dictMap,
  getDicMap: (state) => (code) => getOptions(state.student.dictMap, code)
}

export default getters
